import React, { useEffect, useState } from 'react';
import {
    Modal,
    Box,
    TextField,
    Button,
    Typography,
    IconButton,
    Grid,
    Switch,
    FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CustomTextField } from 'components';

interface EditThresholdModalProps {
    open: boolean;
    handleClose: () => void;
    handleSubmit: (data: ThresholdDetails) => void;
    initialValues: ThresholdDetails;
}

interface ThresholdDetails {
    autoPayThresholdAmount: string;
    autoPay: boolean;
}

export const EditThresholdModal: React.FC<EditThresholdModalProps> = ({ open, handleClose, handleSubmit, initialValues }) => {
    const [autoPayThresholdAmount, setAutoPayThresholdAmount] = useState(initialValues.autoPayThresholdAmount);
    const [autoPay, setAutoPay] = useState(initialValues.autoPay);

    useEffect(() => {
        setAutoPayThresholdAmount(initialValues.autoPayThresholdAmount);
        setAutoPay(initialValues.autoPay);
    }, [initialValues]);

    const onSubmit = () => {
        const data = {
            autoPayThresholdAmount,
            autoPay,
        };
        handleSubmit(data);
        handleClose();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: { xs: '356px', md: '50%' },
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: "292px", md: "500px" },
                    maxHeight: { xs: '100vh', md: "100vh" },
                    overflow: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: { xs: 4, md: 4 },
                    borderRadius: "10px",
                }}
            >
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box display={"flex"} justifyContent={"center"} textAlign={'center'} flexDirection={'column'}
                    pb={{ xs: 5, md: 0 }}>
                    <Typography fontWeight={{ xs: 700, md: 500 }} fontSize={{ xs: 18, md: 28 }} color={{ xs: "#313131", md: "#233F91" }}>

                        Auto Pay Threshold
                    </Typography>
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={3}>

                    <Grid py={3} display={"flex"} flexDirection={{ xs: "column", md: "row" }} gap={{ xs: 1, md: 2 }} >
                        <Typography
                            sx={styleSheet.labelText}
                        >
                            Auto Pay Threshold Amount
                        </Typography>
                        <Box>
                            <CustomTextField
                                name="amount"
                                type='number'
                                sx={{ width: '309px', }}
                                value={autoPayThresholdAmount}
                                onChange={(e) => setAutoPayThresholdAmount(e.target.value)}
                            />
                        </Box>
                    </Grid>

                    <Box>
                        <FormControlLabel
                            label="Auto Pay"
                            labelPlacement="start"
                            sx={{
                                margin: 0,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: { xs: "15px", md: "18px" },
                                    fontWeight: { xs: 400, md: 600 },
                                    color: { xs: "#797979", md: "#313131" },
                                    marginRight: '16px',
                                    overflow: 'hidden',
                                },

                            }}
                            control={
                                <Switch
                                    checked={autoPay}
                                    onChange={(e) => setAutoPay(e.target.checked)}
                                    color="primary"
                                    sx={{
                                        overflow: 'hidden',
                                        '& .MuiSwitch-switchBase': {
                                            padding: "3px",
                                            overflow: 'hidden',
                                            '&.Mui-checked': {
                                                transform: 'translateX(28px)',
                                                color: '#fff',
                                                '& + .MuiSwitch-track': {
                                                    backgroundColor: '#34C759',
                                                    opacity: 1,
                                                    border: 'none',
                                                },
                                            },
                                        },
                                        '& .MuiSwitch-thumb': {
                                            width: 28,
                                            height: 28,
                                            boxShadow: 'none',
                                        },
                                        '& .MuiSwitch-track': {
                                            borderRadius: 26 / 2,
                                            backgroundColor: '#E9E9EA',
                                            opacity: 1,
                                            transition: 'background-color 0.3s',
                                        },

                                        width: 62,
                                        height: 34,
                                        padding: 0,

                                    }}
                                />
                            }
                        />

                    </Box>

                    <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }} gap={2}>
                        <Button onClick={handleClose} sx={{
                            bgcolor: "#EEEEEE",
                            color: "#233f91",
                            width: "87px",
                            height: "48px",
                            border: "1.5px solid #233F91",
                            borderRadius: "15px",
                            '&:hover': {
                                bgcolor: "#cccccc",
                            },
                        }}>
                            Cancel
                        </Button>
                        <Button sx={{
                            bgcolor: "#233f91",
                            color: "#fff",
                            width: "83px",
                            height: "48px",
                            borderRadius: "15px",
                            '&:hover': {
                                bgcolor: "#1565c0",
                                color: "#fff",
                            },
                        }} onClick={onSubmit}>
                            Save
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};


const styleSheet = {
    labelText: {
        fontSize: { xs: "15px", md: "18px" },
        fontWeight: { xs: 400, md: 700 },
        color: { xs: "#797979", md: "#313131" },
    }
}